(() => {
 const root=document.getElementById('md-dream-shop-motion-preview');if(!root)return;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),button=root.querySelector('.md-pause-all');
 const videos=[...root.querySelectorAll('video[data-motion-src]')];let paused=reduced.matches;
 const visibility=new WeakMap(),pending=new WeakMap();
 const allowed=v=>!paused&&!document.hidden&&visibility.get(v)===true;
 const sync=v=>{
  if(!allowed(v)){v.pause();return;}
  if(v.getAttribute('src')){v.play().catch(()=>{});return;}
  if(pending.has(v))return;
  const request=fetch(v.dataset.motionSrc).then(r=>{if(!r.ok)throw new Error('motion');return r.json();}).then(data=>{
   v.src=data.src;v.load();if(allowed(v))v.play().catch(()=>{});
  }).catch(()=>{pending.delete(v);});pending.set(v,request);
 };
 const apply=()=>{root.toggleAttribute('data-paused',paused);button.textContent=paused?button.dataset.resumeLabel:button.dataset.pauseLabel;button.setAttribute('aria-pressed',String(paused));videos.forEach(sync);};
 const observer=new IntersectionObserver(entries=>entries.forEach(e=>{visibility.set(e.target,e.isIntersecting);sync(e.target);}),{threshold:.05});
 videos.forEach(v=>observer.observe(v));button.addEventListener('click',()=>{paused=!paused;apply();});
 document.addEventListener('visibilitychange',()=>videos.forEach(sync));reduced.addEventListener('change',()=>{paused=reduced.matches;apply();});
 const pair=videos.filter(v=>v.matches('.md-raptor,.md-baby'));let paired=false;
 pair.forEach(v=>v.addEventListener('loadeddata',()=>{if(!paired&&pair.every(x=>x.readyState>=2)){paired=true;pair.forEach(x=>{x.currentTime=0;sync(x);});}}));
 apply();
})();
